import React, { useContext } from 'react';
import { Form, FormControl, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { UserContext } from '../../App';
import logo from '../../logo.png';
import './Header.css';

const Header = () => {
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    const handleLogOut = () => {
       setLoggedInUser('');
    }
    return (
        <Navbar  variant="light" className="d-flex justify-content-around sticky-top box3">
            <Link to="/"><img src={logo} alt="" className="icon" /></Link>
            <Form inline>
                <FormControl type="search" placeholder="Search Destination..." />
            </Form>
            <Nav className="">
                <Link className="btn" to="/guide">Guide</Link>
                <Link className="btn" to="/hotel">Hotel</Link>
                <Link className="btn" to="/booking">Booking</Link>
                
                {
                    loggedInUser.email ?
                        <Link onClick={handleLogOut} className="btn btn-warning" to="/">Log Out</Link>
                        :
                        <Link className="btn btn-warning" to="/login">Log In</Link>
                }
            </Nav>
        </Navbar>
    );
};

export default Header;